module.exports = __webpack_public_path__ + "static/media/hamburger.a268186e.svg";